import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { LogoWidget } from '../logowidget/logowidget.component';

@Component({
    selector: 'topbar-widget',
    standalone: true,
    imports: [CommonModule, RouterLink, LogoWidget],
    templateUrl: './topbarwidget.component.html'
})
export class TopbarWidget implements OnInit, OnDestroy {
    openMobileMenu = false;

    maxHeight = '0px';

    isAtTop = true;

    activeRouteName: string = '';

    private destroy$ = new Subject<void>();

    get isBuzonRoute(): boolean {
        return this.activeRouteName.startsWith('/buzon');
    }

    @ViewChild('menuContent') menuContent?: ElementRef<HTMLDivElement>;

    navs: { name: string; label: string; to: string }[] = [
        // {name: 'about', label: 'About', to: '/landing/about'},
        // {name: 'pricing', label: 'Pricing', to: '/landing/pricing'},
        // {name: 'contact', label: 'Contact', to: '/landing/contact'}
    ];

    constructor(
        private router: Router,
        private elRef: ElementRef
    ) {}

    ngOnInit() {
        this.activeRouteName = this.router.url;
        window.addEventListener('scroll', this.handleScroll);

        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            takeUntil(this.destroy$)
        ).subscribe((e) => {
            this.activeRouteName = (e as NavigationEnd).urlAfterRedirects;
        });
    }

    handleScroll = () => {
        this.isAtTop = window.scrollY === 0;
    };

    toggleMobileMenu() {
        this.openMobileMenu = !this.openMobileMenu;
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        const navElement = this.elRef.nativeElement;
        if (navElement && !navElement.contains(event.target)) {
            this.openMobileMenu = false;
        }
    }

    get maxHeightStyle(): string {
        return this.openMobileMenu ? `${this.menuContent?.nativeElement.scrollHeight}px` : this.maxHeight;
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        this.destroy$.next();
        this.destroy$.complete();
    }
}
